import { NodeSelection, TextSelection } from '@atlaskit/editor-prosemirror/state';
function findEmptySelectableParentNodePosition($pos, isValidPosition) {
  var doc = $pos.doc;
  if ($pos.pos + 1 > doc.content.size) {
    return null;
  }
  if ($pos.depth === 0) {
    if (isValidPosition($pos)) {
      return $pos;
    }

    // We can not use `$pos.before()` because ProseMirror throws an error when depth is zero.
    var currentPosIndex = $pos.index();
    if (currentPosIndex === 0) {
      return null;
    }
    var previousIndex = currentPosIndex - 1;
    var $previousPos = $pos.doc.resolve($pos.posAtIndex(previousIndex));
    if (isValidPosition($previousPos)) {
      return $previousPos;
    }
    return null;
  }
  if (isValidPosition($pos)) {
    return $pos;
  }
  var positionLevelUp = $pos.before();
  var resolvedPositionLevelUp = doc.resolve(positionLevelUp);
  return findEmptySelectableParentNodePosition(resolvedPositionLevelUp, isValidPosition);
}
var checkPositionNode = function checkPositionNode($pos) {
  var maybeNode = $pos.nodeAfter;
  if (!maybeNode || !maybeNode.isBlock) {
    return false;
  }
  if (maybeNode.isAtom) {
    return true;
  }
  var isParentEmpty = maybeNode.content.size === 0 || maybeNode.textContent === '';
  return isParentEmpty && NodeSelection.isSelectable(maybeNode);
};
function findNextSelectionPosition(_ref) {
  var $targetHead = _ref.$targetHead,
    $anchor = _ref.$anchor,
    doc = _ref.doc;
  var direction = $anchor.pos < $targetHead.pos ? 'down' : 'up';
  var maybeNextPosition = findEmptySelectableParentNodePosition($targetHead, checkPositionNode);
  if (maybeNextPosition && maybeNextPosition.nodeAfter) {
    var nodeAfter = maybeNextPosition.nodeAfter;
    var pos = maybeNextPosition.pos;
    var nextPositionToSelect = direction === 'down' ? Math.min(nodeAfter.nodeSize + pos, doc.content.size) : Math.max(pos, 0);
    return doc.resolve(nextPositionToSelect);
  }
  return null;
}
export var onCreateSelectionBetween = function onCreateSelectionBetween(view, $anchor, $head) {
  var _$head$parent;
  if ($anchor.pos === $head.pos) {
    return null;
  }
  if ($anchor.depth === $head.depth && $anchor.sameParent($head)) {
    return null;
  }

  // If the head is targeting a paragraph on root, then let ProseMirror handle the text selection
  if ($head.depth === 1 && ((_$head$parent = $head.parent) === null || _$head$parent === void 0 ? void 0 : _$head$parent.type.name) === 'paragraph') {
    return null;
  }
  var $nextHeadPosition = findNextSelectionPosition({
    $targetHead: $head,
    $anchor: $anchor,
    doc: view.state.doc
  });
  if (!$nextHeadPosition) {
    return null;
  }
  var forcedTextSelection = TextSelection.create(view.state.doc, $anchor.pos, $nextHeadPosition.pos);
  return forcedTextSelection;
};